import { writable } from 'svelte/store';

const object_ = writable({});

const objectStore = {
    subscribe: object_.subscribe,
    updateItem: (updatedItem) => 
    object_.update(item =>{
        item = updatedItem
        return item;    
    })   
}
export default objectStore 